import { useParams } from 'react-router-dom';
import DossierOverviewFields from '../../../components/dossier-overview/DossierOverviewFields';
import EmailStakeholdersAction from '../../../components/stakeholders/EmailStakeholdersAction';
import { DOSSIER_OVERVIEW_SCHOOLS_RESOURCE } from '../../../resources/dossier.overview.schools.resource';
import { DOSSIER_OVERVIEW_STAKEHOLDERS_RESOURCE } from '../../../resources/dossier.overview.stakeholders.resource';

import StaticTable from '../../core/StaticTable';

const DossierDetailOverview = ({ data, permissions, onUpdated }) => {
  const params = useParams();

  if (!permissions.read) {
    return null;
  }

  return (
    <div>
      <DossierOverviewFields
        write={permissions?.write}
        dossierId={params.id}
        data={data?.overview}
        onUpdated={onUpdated}
      />
      <StaticTable
        resource={DOSSIER_OVERVIEW_STAKEHOLDERS_RESOURCE}
        data={data?.overview?.involved ?? []}
        responsive
        actions={[
          <EmailStakeholdersAction
            key="stakeholder-email"
            className="u-margin-right-sm"
            stakeholders={data?.overview?.involved ?? []}
          />
        ]}
      />
      <div className={data?.overview?.school?.length < 4 ? 'u-margin-bottom-xxl' : ''}>
        <StaticTable resource={DOSSIER_OVERVIEW_SCHOOLS_RESOURCE} data={data?.overview?.school ?? []} responsive />
      </div>
    </div>
  );
};

export default DossierDetailOverview;
